// Parent/student attendance amendment requests, subject attendance reports
// (mobile endpoints) and the family leave-request form. Every string must stay
// globally unique across sagas — prefixed SP_ATT_ (grep before adding).
export const SP_ATT_SUBJECT_INDIVIDUAL = 'SP_ATT_SUBJECT_INDIVIDUAL'
export const SP_ATT_SUBJECT_COMBINE = 'SP_ATT_SUBJECT_COMBINE'
export const SP_ATT_USER_SUBJECTS = 'SP_ATT_USER_SUBJECTS'
export const SP_ATT_NOTIFICATION_READ = 'SP_ATT_NOTIFICATION_READ'
export const SP_ATT_AMENDMENT_LIST = 'SP_ATT_AMENDMENT_LIST'
export const SP_ATT_AMENDMENT_SHOW = 'SP_ATT_AMENDMENT_SHOW'
export const SP_ATT_AMENDMENT_CREATE = 'SP_ATT_AMENDMENT_CREATE'
export const SP_ATT_DAY_CAMPUS = 'SP_ATT_DAY_CAMPUS'
export const SP_ATT_DAY_SUBJECT = 'SP_ATT_DAY_SUBJECT'
export const SP_ATT_LEAVE_SCHEDULES = 'SP_ATT_LEAVE_SCHEDULES'
export const SP_ATT_LEAVE_EXAMS = 'SP_ATT_LEAVE_EXAMS'
export const SP_ATT_LEAVE_TESTS = 'SP_ATT_LEAVE_TESTS'
export const SP_ATT_LEAVE_HOMEWORK = 'SP_ATT_LEAVE_HOMEWORK'
export const SP_ATT_LEAVE_CREATE = 'SP_ATT_LEAVE_CREATE'
